export enum JobTabType {
  Application = "application",
  AI = "ai",
  Overview= "overview"
}

export enum PaymentMethodType {
  Paypal = "paypal",
  Crypto = "crypto",
}

export enum MilestoneStatusKey {
  INITIATED = 'initiated',
  IN_PROGRESS = 'in-progress',
  SUBMITTED = 'submitted',
  REVIEWED = 'reviewed',
  NEEDS_REWORK = 'needs-rework',
  REJECTED = 'rejected',
  APPROVED = 'approved',
}

export enum ContractStatusKey {
  PENDING = 'pending',
  ACTIVE = 'activated',
  ACCEPTED = 'accepted', 
  IN_PROGRESS = 'in-progress',
  COMPLETED = 'completed',
  CANCELLED = 'cancelled',
  REJECTED = 'rejected',
}

export enum TermAndConditionType {
  File = "file",
  CheckBox = "checkbox"
}

export enum ContractFilterText {
  All = "all"
};

export enum ApplicationStatus {
  APPLIED = 1,
  VIEWED = 2,
  INTERVIEW = 3,
  ACCEPTED = 4,
  ONHOLD = 5,
  REJECTED = 6,
  WITHDRAWN = 7
};

export enum NotificationName {
  JOB_APPLIED = "Job Applied!",
  CONTRACT_CREATED = "Contract Created!",
  MILESTONE_CREATED = "Milestone Created!",
  STATUS_UPDATED = "Status Updated!",
};

export enum NotificationHeader {
  MILESTONE = "Milestone",
  APPLICATION = "Application",
  CONTRACT = "Contract",
};

export enum ContractStatus {
  INITIATED = 1,
  ACCEPTED = 2,
  IN_PROGRESS = 3,
  COMPLETED = 4,
  CANCELLED = 5,
  REJECTED = 6,
};

export enum MilestoneStatus {
  INITIATED = 1,
  IN_PROGRESS = 2,
  SUBMITTED = 3,
  REVIEWED = 4,
  NEEDS_REWORK = 5,
  REJECTED = 6,
  APPROVED = 7,
};